import { ColumnConfigurationMap } from '../types'
import { DELIVERY_TABLE_COLUMN_DEFINITIONS } from './delivery-table-column-definitions'
import { SUBSCRIBER_TABLE_COLUMN_DEFINITIONS } from './subscriber-table-column-definitions'
import { MONTHLY_UNIQUES_TABLE_COLUMN_DEFINITIONS } from './monthly-uniques-table-column-definitions'
import { PUB_NETWORK_TABLE_COLUMN_DEFINITIONS } from './pub-network-table-column-definitions'
import { APP_MESSAGE_TABLE_COLUMN_DEFINITIONS } from './app-message-table-column-definitions'
import { LIVE_ACTIVITY_TABLE_COLUMN_DEFINITIONS } from './live-activity-table-column-definitions'
import { ReportConfigurationType } from '../enums/report-configuration-type'

export const COLUMN_CONFIGS_BY_TYPE_MAP: Record<ReportConfigurationType, ColumnConfigurationMap> = {
    [ReportConfigurationType.NONE]: {},
    [ReportConfigurationType.DELIVERY]: DELIVERY_TABLE_COLUMN_DEFINITIONS,
    [ReportConfigurationType.SUBSCRIBER]: SUBSCRIBER_TABLE_COLUMN_DEFINITIONS,
    [ReportConfigurationType.MONTHLY_UNIQUES]: MONTHLY_UNIQUES_TABLE_COLUMN_DEFINITIONS,
    [ReportConfigurationType.PUB_NETWORK]: PUB_NETWORK_TABLE_COLUMN_DEFINITIONS,
    [ReportConfigurationType.APP_MESSAGE]: APP_MESSAGE_TABLE_COLUMN_DEFINITIONS,
    [ReportConfigurationType.LIVE_ACTIVITY]: LIVE_ACTIVITY_TABLE_COLUMN_DEFINITIONS,
}
